import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

function prefersDarkMode() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
  );
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("rs_theme") || "light");

  useEffect(() => {
    const root = document.documentElement;
    const applyTheme = () => {
      const shouldUseDark = theme === "dark" || (theme === "system" && prefersDarkMode());
      root.classList.toggle("dark", shouldUseDark);
    };

    applyTheme();
    localStorage.setItem("rs_theme", theme);

    if (theme !== "system" || typeof window === "undefined") return undefined;

    const mediaQuery = window.matchMedia?.("(prefers-color-scheme: dark)");
    mediaQuery?.addEventListener?.("change", applyTheme);

    return () => {
      mediaQuery?.removeEventListener?.("change", applyTheme);
    };
  }, [theme]);

  const toggle = () => {
    setTheme((current) => {
      const resolvedTheme = current === "system" ? (prefersDarkMode() ? "dark" : "light") : current;
      return resolvedTheme === "dark" ? "light" : "dark";
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
